import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { RootState } from "../../store"
import { API_STATUS, DATE_FORMAT, monthOptions } from "../../util/StaticData"
import { IDropDownOptions, IUseCaseOptions } from "../../util/interface"
import {
  CreateDropDownOptions,
  parseAndFormatDate,
} from "../../util/CommonMethods"
import AxiosOperations from "../../services/AxiosOperations"
import { API } from "../../util/api"
import {
  format,
  // getMonth,
  // getYear
} from "date-fns"

const marketSelectedValue: IDropDownOptions[] = []
export const initialState = {
  status: "idle",
  useCaseFilterOptionsData: [],
  marketSingleFilterOptionsData: [],
  marketFilterOptionsData: [],
  useCaseStatus: API_STATUS.IDLE,
  marketSingleCaseStatus: API_STATUS.IDLE,
  marketStatus: API_STATUS.IDLE,
  useCaseSelectedValue: "",
  marketSingleCaseSelectedValue: "",
  marketSelectedValue,
  timePeriodSelectedValue: "month",

  pipeLineSelectedValue: "",
  pipeLineOptionsData: [] as any,
  pipeLineStatus: API_STATUS.IDLE,

  runIdSelectedValue: "",
  runIdOptionsData: [] as any,

  pipeLineNamesAndRunIdsRawData: [],
  //date/ month/ year
  startDate: "",
  endDate: "",

  // monthSelectedValue: monthOptions[getMonth(new Date())].value,
  monthSelectedValue: monthOptions[0].value,

  // yearSelectedValue: `${getYear(new Date())}`,
  yearSelectedValue: `2025`,
}

export const filterUseCaseOptionsAsync = createAsyncThunk(
  "filters/useCaseOptions",
  async () => {
    try {
      const payload = {
        is_parent: true,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.USECASE_OPTIONS, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)
export const marketSingleFilterOptionsAsync = createAsyncThunk(
  "filters/marketSingleOptions",
  async () => {
    try {
      const payload = {
        is_parent: true,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.MARKET_FILTER, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const pipeLineNamesAndRunIdsAsync = createAsyncThunk(
  "filters/pipeLineNamesAndRunIds",
  async (_, { getState }) => {
    try {
      const state: any = getState()
      let startFormattedDate
      let endFormattedDate
      if (state.filters.startDate && state.filters.endDate) {
        startFormattedDate = parseAndFormatDate(
          state.filters.startDate,
          DATE_FORMAT,
          "yyyy-MM-dd",
        )
        endFormattedDate = parseAndFormatDate(
          state.filters.endDate,
          DATE_FORMAT,
          "yyyy-MM-dd",
        )
      }

      const payload = {
        use_case: state.filters.useCaseSelectedValue,
        market_place: state.filters.marketSingleCaseSelectedValue,
        start_date: startFormattedDate,
        end_date: endFormattedDate,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      }
      if (!payload.end_date || !payload.start_date) {
        delete payload.start_date
        delete payload.end_date
      }

      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.DATA_METADATA_PIPELINE_NAME_AND_RUN_ID, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const filterSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    useCaseFilterChange: (state, action: PayloadAction<string>) => {
      state.useCaseSelectedValue = action.payload
    },
    marketSingleSelectionFilterChange: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.marketSingleCaseSelectedValue = action.payload
    },
    timePeriodFilterChange: (state, action: PayloadAction<string>) => {
      state.timePeriodSelectedValue = action.payload
    },
    pipeLineFilterChange: (state, action: PayloadAction<string>) => {
      state.pipeLineSelectedValue = action.payload
    },
    updateMarketFilters: (state) => {
      state.marketFilterOptionsData = [...state.marketFilterOptionsData]
    },
    runIdChange: (state, action: PayloadAction<string>) => {
      state.runIdSelectedValue = action.payload
    },
    startDateChange: (state, action: PayloadAction<string>) => {
      state.startDate = action.payload
    },
    endDateChange: (state, action: PayloadAction<string>) => {
      state.endDate = action.payload
    },
    updateStartAndEndDateBasedOnRunId: (state) => {
      try {
        const { start_time, end_time } = findRunDetailsByRunId(
          state.pipeLineSelectedValue,
          state.runIdSelectedValue,
          state.pipeLineNamesAndRunIdsRawData,
        )
        if (start_time && end_time) {
          state.startDate = format(new Date(start_time), DATE_FORMAT)
          state.endDate = format(new Date(end_time), DATE_FORMAT)
        }
      } catch (error) {
        console.error(error)
      }
    },
    pipeLineNameFilterChange: (state) => {
      const temp: any = state.pipeLineNamesAndRunIdsRawData.find((obj) => {
        return obj["pipeline_name"] == state.pipeLineSelectedValue
      })
      state.runIdOptionsData = CreateDropDownOptions(
        temp["az_pipeline_run_ids"].map((o: any) => o.az_pipeline_run_id)
          ? temp["az_pipeline_run_ids"].map((o: any) => o.az_pipeline_run_id)
          : [],
      )
    },
    monthFilterChange: (state, action: PayloadAction<string>) => {
      state.monthSelectedValue = action.payload
    },
    yearFilterChange: (state, action: PayloadAction<string>) => {
      state.yearSelectedValue = action.payload
    },
    resetFullFilterSlice: () => {
      return structuredClone(initialState)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(filterUseCaseOptionsAsync.pending, (state) => {
        state.useCaseStatus = API_STATUS.LOADING
      })
      .addCase(
        filterUseCaseOptionsAsync.fulfilled,
        (state, action: { payload: { last_run: IUseCaseOptions[] } }) => {
          try {
            state.useCaseStatus = API_STATUS.IDLE
            const temp = action.payload.last_run.map((obj) => obj.name)
            state.useCaseFilterOptionsData = CreateDropDownOptions(temp).sort(
              (a, b) => a["label"].localeCompare(b["label"]),
            ) as any
            state.useCaseSelectedValue =
              // state.useCaseFilterOptionsData[0]["value"]
              state.useCaseFilterOptionsData[0]["value"]
          } catch (error) {
            state.useCaseStatus = API_STATUS.FAILED
          }
        },
      )
      .addCase(filterUseCaseOptionsAsync.rejected, (state) => {
        state.useCaseStatus = API_STATUS.FAILED
      })
      .addCase(marketSingleFilterOptionsAsync.pending, (state) => {
        state.marketSingleCaseStatus = API_STATUS.LOADING
      })
      .addCase(
        marketSingleFilterOptionsAsync.fulfilled,
        (state, action: { payload: { last_run: IUseCaseOptions[] } }) => {
          try {
            state.marketSingleCaseStatus = API_STATUS.IDLE
            const temp = action.payload.last_run.map((obj) => obj.name)
            state.marketSingleFilterOptionsData = CreateDropDownOptions(
              temp,
            ).sort((a, b) => b["label"].localeCompare(a["label"])) as any
            state.marketSingleCaseSelectedValue =
              // state.marketSingleFilterOptionsData[0]["value"]
              state.marketSingleFilterOptionsData[0]["value"]
          } catch (error) {
            state.marketSingleCaseStatus = API_STATUS.FAILED
          }
        },
      )
      .addCase(marketSingleFilterOptionsAsync.rejected, (state) => {
        state.marketSingleCaseStatus = API_STATUS.FAILED
      })
      .addCase(pipeLineNamesAndRunIdsAsync.pending, () => {})
      .addCase(
        pipeLineNamesAndRunIdsAsync.fulfilled,
        (state, action: { payload: any }) => {
          try {
            state.pipeLineOptionsData = CreateDropDownOptions(
              action["payload"].map((obj: any) => obj.pipeline_name),
            )
            if (!state.pipeLineOptionsData.length) {
              state.runIdOptionsData = []
            }
            state.pipeLineNamesAndRunIdsRawData = action.payload
          } catch (error) {
            console.error(error)
          }
        },
      )
      .addCase(pipeLineNamesAndRunIdsAsync.rejected, () => {})
  },
})
export const timePeriodSelectedValueSelector = (state: RootState) =>
  state.filters.timePeriodSelectedValue

export const useCaseSelectedValueSelector = (state: RootState) =>
  state.filters.useCaseSelectedValue
export const useCaseStatusSelector = (state: RootState) =>
  state.filters.useCaseStatus
export const useCaseFilterOptionsSelector = (state: RootState) =>
  state.filters.useCaseFilterOptionsData

export const marketSelectedValueSelector = (state: RootState) =>
  state.filters.marketSelectedValue
export const marketStatusSelector = (state: RootState) =>
  state.filters.marketStatus
export const marketFilterOptionsSelector = (state: RootState) =>
  state.filters.marketFilterOptionsData

export const marketSinleSelectedValueSelector = (state: RootState) =>
  state.filters.marketSingleCaseSelectedValue
export const marketSinleStatusSelector = (state: RootState) =>
  state.filters.marketSingleCaseStatus
export const marketSinleFilterOptionsSelector = (state: RootState) =>
  state.filters.marketSingleFilterOptionsData

export const pipeLineSelectedValueSelector = (state: RootState) =>
  state.filters.pipeLineSelectedValue
export const pipeLineStatusSelector = (state: RootState) =>
  state.filters.pipeLineStatus
export const pipeLineFilterOptionsSelector = (state: RootState) =>
  state.filters.pipeLineOptionsData

export default filterSlice.reducer

export const {
  useCaseFilterChange,
  timePeriodFilterChange,
  updateMarketFilters,
  marketSingleSelectionFilterChange,
  pipeLineFilterChange,
  pipeLineNameFilterChange,
  runIdChange,
  startDateChange,
  endDateChange,
  monthFilterChange,
  yearFilterChange,
  resetFullFilterSlice,
  updateStartAndEndDateBasedOnRunId,
} = filterSlice.actions

function findRunDetailsByRunId(pipeLineName: string, runId: string, data: any) {
  const temp = data.find((obj: any) => {
    return obj.pipeline_name == pipeLineName
  })
  if (temp) {
    const filteredRunId = temp.az_pipeline_run_ids.find((obj: any) => {
      return obj.az_pipeline_run_id == runId
    })
    if (Object.keys(filteredRunId ? filteredRunId : {}).length) {
      return filteredRunId
    }
  }
  return { start_time: "", end_time: "" }
}
